(function () {
  if (window.RealleaderQuoteBasket) return;

  var formSelector = 'form[data-rl-add-to-quote-form]';
  var addDeadlineMs = 12000;
  var cartRefreshDeadlineMs = 10000;
  var pendingQuoteAnalytics = [];
  var mutationCoordinator = window.RealleaderQuoteMutationCoordinator ||
    (window.RealleaderQuoteMutationCoordinator = { state: null });

  if (typeof mutationCoordinator.setState !== 'function') {
    mutationCoordinator.setState = function (nextState) {
      mutationCoordinator.state = nextState || null;
      try {
        window.dispatchEvent(new CustomEvent('realleader:quote-mutation-state', {
          detail: { state: mutationCoordinator.state }
        }));
      } catch (error) {
        // The shared state remains authoritative when CustomEvent is unavailable.
      }
      return mutationCoordinator.state;
    };
  }

  function setMutationCoordinatorState(nextState) {
    return mutationCoordinator.setState(nextState);
  }

  function syncGlobalQuoteMutationControls() {
    var state = mutationCoordinator.state;
    var shouldLock = Boolean(state && state.status === 'in-flight');
    var shouldCheck = Boolean(state && state.status === 'unconfirmed');
    document.querySelectorAll('[data-rl-add-to-quote-button], [data-rlm-add-button], [data-product-atc]').forEach(function (button) {
      if (shouldLock) {
        if (!button.disabled) {
          button.disabled = true;
          button.setAttribute('data-rl-global-quote-mutation-disabled', 'true');
        }
        return;
      }
      if (button.getAttribute('data-rl-global-quote-mutation-disabled') === 'true') {
        button.disabled = false;
        button.removeAttribute('data-rl-global-quote-mutation-disabled');
      }
      var label = button.querySelector('[data-rl-add-to-quote-label], [data-rlm-add-label], .atc-button--text') || button;
      if (shouldCheck) {
        if (!label.hasAttribute('data-rl-global-quote-idle-label')) {
          label.setAttribute('data-rl-global-quote-idle-label', (label.textContent || '').trim());
        }
        label.textContent = 'Check quote basket';
        button.setAttribute('aria-label', 'Check quote basket before adding again');
        button.setAttribute('title', 'Check quote basket before adding again');
      } else if (label.hasAttribute('data-rl-global-quote-idle-label')) {
        label.textContent = label.getAttribute('data-rl-global-quote-idle-label') || 'Add to quote';
        label.removeAttribute('data-rl-global-quote-idle-label');
        button.removeAttribute('aria-label');
        button.removeAttribute('title');
      }
    });
  }

  function timeoutError(message) {
    var error = new Error(message);
    error.name = 'TimeoutError';
    error.code = 'RL_FETCH_TIMEOUT';
    return error;
  }

  function fetchWithDeadline(url, options, deadlineMs, timeoutMessage, handleResponse) {
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var requestOptions = {};

    Object.keys(options || {}).forEach(function (key) {
      requestOptions[key] = options[key];
    });
    if (controller) requestOptions.signal = controller.signal;

    return new Promise(function (resolve, reject) {
      var settled = false;
      var timer = window.setTimeout(function () {
        if (settled) return;
        settled = true;
        if (controller) {
          try {
            controller.abort();
          } catch (error) {
            // Reject with the stable timeout error below even if abort is unavailable here.
          }
        }
        reject(timeoutError(timeoutMessage));
      }, deadlineMs);

      function settle(callback, value) {
        if (settled) return;
        settled = true;
        window.clearTimeout(timer);
        callback(value);
      }

      try {
        fetch(url, requestOptions).then(function (response) {
          return typeof handleResponse === 'function' ? handleResponse(response) : response;
        }).then(function (value) {
          settle(resolve, value);
        }, function (error) {
          settle(reject, error);
        });
      } catch (error) {
        settle(reject, error);
      }
    });
  }

  function withFinally(promise, callback) {
    if (typeof promise.finally === 'function') return promise.finally(callback);
    return promise.then(function (value) {
      callback();
      return value;
    }, function (error) {
      callback();
      throw error;
    });
  }

  function addJsSuffix(url) {
    return /\.js($|\?)/.test(url) ? url : url.replace(/(\?.*)?$/, '.js$1');
  }

  function updateHeaderCount(count) {
    count = Math.max(0, Number(count) || 0);
    document.querySelectorAll('[data-header-cart-count], [data-rl-cart-count]').forEach(function (countEl) {
      var visible = count > 0;
      countEl.textContent = visible ? String(count) : '';
      if (countEl.hasAttribute('data-header-cart-count')) {
        countEl.dataset.headerCartCount = visible ? String(count) : '';
      }
      countEl.hidden = !visible;
      countEl.classList.toggle('visible', visible);
      countEl.classList.toggle('is-visible', visible);
      countEl.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-rl-quote-link]').forEach(function (link) {
      link.setAttribute('aria-label', 'Quote basket, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function cartUrlFor(form) {
    var returnTo = form && form.querySelector('[name="return_to"]');
    if (returnTo && returnTo.value) return returnTo.value;
    if (window.Theme && window.Theme.routes && window.Theme.routes.cart_url) return window.Theme.routes.cart_url;
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
    return root.replace(/\/$/, '') + '/cart';
  }

  function getCart(cartUrl) {
    return fetchWithDeadline(addJsSuffix(cartUrl), {
      headers: { Accept: 'application/json' }
    }, cartRefreshDeadlineMs, 'The quote basket refresh took too long.', function (response) {
      if (!response.ok) throw new Error('Unable to read quote basket.');
      return response.json();
    });
  }

  function currentHeaderCount() {
    var countEl = document.querySelector('[data-header-cart-count], [data-rl-cart-count]');
    if (!countEl) return null;
    var raw = countEl.hasAttribute('data-header-cart-count')
      ? countEl.getAttribute('data-header-cart-count')
      : countEl.textContent;
    raw = String(raw || '').trim();
    if (!raw) return 0;
    var count = Number(raw);
    return isFinite(count) && count >= 0 ? count : null;
  }

  function setStatus(form, message, cartUrl, isError) {
    var status = form.querySelector('[data-rl-add-to-quote-status]');
    if (!status) return;

    status.textContent = '';
    var span = document.createElement('span');
    span.textContent = message;
    status.appendChild(span);

    if (cartUrl) {
      status.appendChild(document.createTextNode(' '));
      var link = document.createElement('a');
      link.href = cartUrl;
      link.textContent = 'View quote basket';
      status.appendChild(link);
    }

    status.setAttribute('role', isError ? 'alert' : 'status');
    if (isError) {
      status.setAttribute('tabindex', '-1');
      status.focus();
    } else {
      status.removeAttribute('tabindex');
    }
  }

  function setButtonLabel(button, text) {
    var label = button && button.querySelector('[data-rl-add-to-quote-label]');
    if (label) label.textContent = text;
  }

  function setFormInFlight(form, button, inFlight) {
    if (inFlight) {
      form.classList.add('is-loading');
      form.dataset.rlQuoteBasketInFlight = 'true';
      form.setAttribute('aria-busy', 'true');
      if (button && !button.disabled) {
        button.dataset.rlQuoteBasketMadeDisabled = 'true';
        button.disabled = true;
      }
      return;
    }

    form.classList.remove('is-loading');
    form.removeAttribute('data-rl-quote-basket-in-flight');
    form.removeAttribute('aria-busy');
    form.querySelectorAll('[data-rl-quote-basket-made-disabled="true"]').forEach(function (control) {
      control.disabled = false;
      delete control.dataset.rlQuoteBasketMadeDisabled;
    });
  }

  function markMutationUnconfirmed(form, button) {
    form.dataset.rlQuoteAddUnconfirmed = 'true';
    if (!button) return;
    setButtonLabel(button, 'Check quote basket');
    button.setAttribute('aria-label', 'Check quote basket before adding again');
    button.setAttribute('title', 'Check quote basket before adding again');
  }

  function markGlobalMutationUnconfirmed(cartUrl) {
    setMutationCoordinatorState({
      status: 'unconfirmed',
      cartUrl: cartUrl || '/cart'
    });
    document.querySelectorAll(formSelector).forEach(function (form) {
      var button = form.querySelector('[data-rl-add-to-quote-button]');
      setFormInFlight(form, button, false);
      markMutationUnconfirmed(form, button);
    });
  }

  function clearGlobalMutation(mutationRecord) {
    if (mutationCoordinator.state === mutationRecord) setMutationCoordinatorState(null);
  }

  function navigateToCart(cartUrl) {
    if (window.location && typeof window.location.assign === 'function') {
      window.location.assign(cartUrl);
    } else if (window.location) {
      window.location.href = cartUrl;
    }
  }

  function clearMutationUnconfirmed(form, button) {
    delete form.dataset.rlQuoteAddUnconfirmed;
    if (!button) return;
    button.removeAttribute('aria-label');
    button.removeAttribute('title');
  }

  function quoteAnalyticsPayload(form, formData, cart, requestedQuantity, previousCount) {
    var itemCount = cart && typeof cart.item_count === 'number'
      ? cart.item_count
      : (previousCount === null ? 0 : previousCount + requestedQuantity);
    var payload = {
      product_id: form.getAttribute('data-rlm-product-id') || '',
      variant_id: formData && formData.get('id') || '',
      product_handle: form.getAttribute('data-rlm-product-handle') || '',
      quantity: requestedQuantity,
      quote_item_count: itemCount,
      product_range: form.getAttribute('data-rlm-product-range') || '',
      page_location: window.location.origin + window.location.pathname
    };

    try {
      if (window.RealleaderAttribution &&
          typeof window.RealleaderAttribution.buildQuotePayload === 'function') {
        return window.RealleaderAttribution.buildQuotePayload(form, {
          item_count: itemCount
        });
      }
    } catch (error) {
      // The stable, theme-owned payload above remains available for a later retry.
    }
    return payload;
  }

  function tryPublishQuoteAnalytics(payload) {
    try {
      return Boolean(window.RealleaderAttribution &&
        typeof window.RealleaderAttribution.publishEvent === 'function' &&
        window.RealleaderAttribution.publishEvent('realleader:add_to_quote', payload) === true);
    } catch (error) {
      return false;
    }
  }

  function publishOrQueueQuoteAnalytics(payload) {
    if (tryPublishQuoteAnalytics(payload)) return true;
    pendingQuoteAnalytics.push(payload);
    return false;
  }

  function flushQuoteAnalytics() {
    if (!pendingQuoteAnalytics.length) return;
    pendingQuoteAnalytics = pendingQuoteAnalytics.filter(function (payload) {
      return !tryPublishQuoteAnalytics(payload);
    });
  }

  function normalizeTransientState(event) {
    if (!event || event.persisted !== true) {
      flushQuoteAnalytics();
      return;
    }
    if (mutationCoordinator.state && mutationCoordinator.state.status === 'in-flight') {
      markGlobalMutationUnconfirmed(mutationCoordinator.state.cartUrl);
    }
    document.querySelectorAll(formSelector).forEach(function (form) {
      var button = form.querySelector('[data-rl-add-to-quote-button]');
      var wasInFlight = form.dataset.rlQuoteBasketInFlight === 'true';
      form.dataset.rlQuoteBasketSequence = String((Number(form.dataset.rlQuoteBasketSequence) || 0) + 1);
      setFormInFlight(form, button, false);

      if (wasInFlight) markMutationUnconfirmed(form, button);
      if (form.dataset.rlQuoteAddUnconfirmed === 'true') {
        markMutationUnconfirmed(form, button);
      } else if (button) {
        setButtonLabel(button, form.dataset.rlQuoteIdleLabel || 'Add to quote');
      }
    });
    flushQuoteAnalytics();
  }

  function handleSubmit(event) {
    var form = event.target.closest(formSelector);
    if (!form) return;
    if (!window.fetch || !window.FormData || !window.Promise || !form.action) return;
    var cartUrl = cartUrlFor(form);
    var button = form.querySelector('[data-rl-add-to-quote-button]');
    if (form.dataset.rlQuoteAddUnconfirmed === 'true' ||
        mutationCoordinator.state && mutationCoordinator.state.status === 'unconfirmed') {
      event.preventDefault();
      markMutationUnconfirmed(form, button);
      navigateToCart(mutationCoordinator.state && mutationCoordinator.state.cartUrl || cartUrl);
      return;
    }
    if (form.dataset.rlQuoteBasketInFlight === 'true') {
      event.preventDefault();
      return;
    }
    if (mutationCoordinator.state && mutationCoordinator.state.status === 'in-flight') {
      event.preventDefault();
      setStatus(form, 'Another item is still being added. Wait for it to finish before adding another.', '', true);
      return;
    }

    var quantity = form.querySelector('[name="quantity"]');
    var originalLabel = button ? (button.querySelector('[data-rl-add-to-quote-label]') || button).textContent.trim() : 'Add to quote';
    var previousCount = currentHeaderCount();
    var requestedQuantity;
    var mutationSucceeded = false;
    var formData;
    var requestToken;
    var mutationRecord;

    if (quantity && (!quantity.value || Number(quantity.value) < 1)) {
      quantity.value = '1';
    }
    requestedQuantity = Math.max(1, Math.floor(Number(quantity && quantity.value) || 1));

    try {
      formData = new FormData(form);
    } catch (error) {
      return;
    }

    event.preventDefault();

    mutationRecord = {
      status: 'in-flight',
      cartUrl: cartUrl
    };
    setMutationCoordinatorState(mutationRecord);
    requestToken = String((Number(form.dataset.rlQuoteBasketSequence) || 0) + 1);
    form.dataset.rlQuoteBasketSequence = requestToken;
    form.dataset.rlQuoteIdleLabel = originalLabel || 'Add to quote';
    clearMutationUnconfirmed(form, button);
    setFormInFlight(form, button, true);
    if (button) setButtonLabel(button, 'Adding...');
    form.classList.remove('is-added');

    var operation = fetchWithDeadline(addJsSuffix(form.action), {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData
    }, addDeadlineMs, 'The add request took too long to confirm.', function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (payload) {
          var error = new Error(payload.description || payload.message || 'Unable to add this item.');
          error.rlDefinitiveResponse = true;
          throw error;
        });
      }
      mutationSucceeded = true;
      return response.json().catch(function () { return null; });
    })
      .then(function (addedItem) {
        return getCart(cartUrl).then(function (cart) {
          return { addedItem: addedItem, cart: cart, refreshError: null };
        }).catch(function (error) {
          return { addedItem: addedItem, cart: null, refreshError: error };
        });
      });

    withFinally(operation, function () {
      setFormInFlight(form, button, false);
      if (button && form.dataset.rlQuoteAddUnconfirmed !== 'true') {
        setButtonLabel(button, originalLabel || 'Add to quote');
      }
    }).then(function (result) {
      if (form.dataset.rlQuoteBasketSequence !== requestToken) return;
      clearGlobalMutation(mutationRecord);
      var cart = result.cart;
      if (cart) updateHeaderCount(cart.item_count || 0);
      else if (previousCount !== null) updateHeaderCount(previousCount + requestedQuantity);
      form.classList.add('is-added');
      setStatus(
        form,
        cart
          ? 'Added to quote basket.'
          : 'Item added. We could not refresh the basket count, so open the quote basket to confirm it.',
        cartUrl,
        false
      );
      if (cart) window.dispatchEvent(new CustomEvent('cartcount:update', { detail: cart }));
      publishOrQueueQuoteAnalytics(quoteAnalyticsPayload(form, formData, cart, requestedQuantity, previousCount));
    }, function (error) {
      if (form.dataset.rlQuoteBasketSequence !== requestToken) return;
      if (mutationSucceeded) {
        clearGlobalMutation(mutationRecord);
        if (previousCount !== null) updateHeaderCount(previousCount + requestedQuantity);
        form.classList.add('is-added');
        setStatus(form, 'Item added. Open the quote basket to confirm the latest contents.', cartUrl, false);
        publishOrQueueQuoteAnalytics(quoteAnalyticsPayload(form, formData, null, requestedQuantity, previousCount));
        return;
      }

      if (!error || error.rlDefinitiveResponse !== true) {
        if (mutationCoordinator.state === mutationRecord) markGlobalMutationUnconfirmed(cartUrl);
        setStatus(
          form,
          'We could not confirm whether this item was added. Check your quote basket before adding it again.',
          cartUrl,
          true
        );
        return;
      }
      clearGlobalMutation(mutationRecord);
      setStatus(form, error.message || 'Unable to add this item.', '', true);
    });
  }

  document.addEventListener('submit', handleSubmit);
  window.addEventListener('cartcount:update', function (event) {
    var cart = event.detail;
    if (!cart || typeof cart.item_count !== 'number') return;
    updateHeaderCount(cart.item_count);
  });
  document.addEventListener('visitorConsentCollected', flushQuoteAnalytics);
  document.addEventListener('realleader:attribution-ready', flushQuoteAnalytics);
  window.addEventListener('realleader:quote-mutation-state', syncGlobalQuoteMutationControls);
  window.addEventListener('pageshow', normalizeTransientState);
  syncGlobalQuoteMutationControls();
  window.RealleaderQuoteBasket = {
    updateHeaderCount: updateHeaderCount,
    flushQuoteAnalytics: flushQuoteAnalytics
  };
})();
